/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type CurrentArtifactVersions,
    CurrentArtifactVersionsFromJSON,
    CurrentArtifactVersionsToJSON,
} from '../models/CurrentArtifactVersions';
import {
    type DownloadToken,
    DownloadTokenFromJSON,
    DownloadTokenToJSON,
} from '../models/DownloadToken';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type ProvisioningPayload,
    ProvisioningPayloadFromJSON,
    ProvisioningPayloadToJSON,
} from '../models/ProvisioningPayload';

export interface ArtifactsAndroidAppApkDownloadRequest {
    expectedVersion: string;
    token?: DownloadToken;
}

export interface ArtifactsAndroidElooperatorApkDownloadRequest {
    expectedVersion: string;
    token?: DownloadToken;
}

export interface ArtifactsAndroidEloserviceApkDownloadRequest {
    expectedVersion: string;
    token?: DownloadToken;
}

export interface ArtifactsFirmwareEloboxDownloadRequest {
    expectedVersion: string;
}

export interface ArtifactsFirmwareMotionSensorDownloadRequest {
    expectedVersion: string;
}

/**
 * ArtifactsApi - interface
 * 
 * @export
 * @interface ArtifactsApiInterface
 */
export interface ArtifactsApiInterface {
    /**
     * Creates request options for artifactsAndroidAppApkDownload without sending the request
     * @param {string} expectedVersion 
     * @param {DownloadToken} [token] 
     * @throws {RequiredError}
     * @memberof ArtifactsApiInterface
     */
    artifactsAndroidAppApkDownloadRequestOpts(requestParameters: ArtifactsAndroidAppApkDownloadRequest): Promise<runtime.RequestOpts>;

    /**
     * Authentication is done via login or download token.  This route is special and has different behavior in dev mode. It and serves the current artifact directly from the disk, with the version number that\'s found in the `.env` file.
     * @summary Return embedded Android app apk for download.
     * @param {string} expectedVersion 
     * @param {DownloadToken} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtifactsApiInterface
     */
    artifactsAndroidAppApkDownloadRaw(requestParameters: ArtifactsAndroidAppApkDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Authentication is done via login or download token.  This route is special and has different behavior in dev mode. It and serves the current artifact directly from the disk, with the version number that\'s found in the `.env` file.
     * Return embedded Android app apk for download.
     */
    artifactsAndroidAppApkDownload(requestParameters: ArtifactsAndroidAppApkDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * Creates request options for artifactsAndroidElooperatorApkDownload without sending the request
     * @param {string} expectedVersion 
     * @param {DownloadToken} [token] 
     * @throws {RequiredError}
     * @memberof ArtifactsApiInterface
     */
    artifactsAndroidElooperatorApkDownloadRequestOpts(requestParameters: ArtifactsAndroidElooperatorApkDownloadRequest): Promise<runtime.RequestOpts>;

    /**
     * Authentication is done via login or download token.  This route is special and has different behavior in dev mode. It serves the current artifact directly from the disk, with the version number that\'s found in the `.env` file.
     * @summary Return embedded Android `ELOoperator` APK for download.
     * @param {string} expectedVersion 
     * @param {DownloadToken} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtifactsApiInterface
     */
    artifactsAndroidElooperatorApkDownloadRaw(requestParameters: ArtifactsAndroidElooperatorApkDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Authentication is done via login or download token.  This route is special and has different behavior in dev mode. It serves the current artifact directly from the disk, with the version number that\'s found in the `.env` file.
     * Return embedded Android `ELOoperator` APK for download.
     */
    artifactsAndroidElooperatorApkDownload(requestParameters: ArtifactsAndroidElooperatorApkDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * Creates request options for artifactsAndroidEloserviceApkDownload without sending the request
     * @param {string} expectedVersion 
     * @param {DownloadToken} [token] 
     * @throws {RequiredError}
     * @memberof ArtifactsApiInterface
     */
    artifactsAndroidEloserviceApkDownloadRequestOpts(requestParameters: ArtifactsAndroidEloserviceApkDownloadRequest): Promise<runtime.RequestOpts>;

    /**
     * Authentication is done via login or download token.  This route is special and has different behavior in dev mode. It serves the current artifact directly from the disk, with the version number that\'s found in the `.env` file.
     * @summary Return embedded Android `ELOservice` APK for download.
     * @param {string} expectedVersion 
     * @param {DownloadToken} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtifactsApiInterface
     */
    artifactsAndroidEloserviceApkDownloadRaw(requestParameters: ArtifactsAndroidEloserviceApkDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Authentication is done via login or download token.  This route is special and has different behavior in dev mode. It serves the current artifact directly from the disk, with the version number that\'s found in the `.env` file.
     * Return embedded Android `ELOservice` APK for download.
     */
    artifactsAndroidEloserviceApkDownload(requestParameters: ArtifactsAndroidEloserviceApkDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * Creates request options for artifactsFirmwareEloboxDownload without sending the request
     * @param {string} expectedVersion 
     * @throws {RequiredError}
     * @memberof ArtifactsApiInterface
     */
    artifactsFirmwareEloboxDownloadRequestOpts(requestParameters: ArtifactsFirmwareEloboxDownloadRequest): Promise<runtime.RequestOpts>;

    /**
     * This route is special and has different behavior in dev mode. It and serves the current artifact directly from the disk, with the version number that\'s found in the `.env` file.
     * @summary Return embedded ELObox firmware.
     * @param {string} expectedVersion 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtifactsApiInterface
     */
    artifactsFirmwareEloboxDownloadRaw(requestParameters: ArtifactsFirmwareEloboxDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * This route is special and has different behavior in dev mode. It and serves the current artifact directly from the disk, with the version number that\'s found in the `.env` file.
     * Return embedded ELObox firmware.
     */
    artifactsFirmwareEloboxDownload(requestParameters: ArtifactsFirmwareEloboxDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * Creates request options for artifactsFirmwareMotionSensorDownload without sending the request
     * @param {string} expectedVersion 
     * @throws {RequiredError}
     * @memberof ArtifactsApiInterface
     */
    artifactsFirmwareMotionSensorDownloadRequestOpts(requestParameters: ArtifactsFirmwareMotionSensorDownloadRequest): Promise<runtime.RequestOpts>;

    /**
     * This route is special and has different behavior in dev mode. It and serves the current artifact directly from the disk, with the version number that\'s found in the `.env` file.
     * @summary Return embedded motion sensor firmware.
     * @param {string} expectedVersion 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtifactsApiInterface
     */
    artifactsFirmwareMotionSensorDownloadRaw(requestParameters: ArtifactsFirmwareMotionSensorDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * This route is special and has different behavior in dev mode. It and serves the current artifact directly from the disk, with the version number that\'s found in the `.env` file.
     * Return embedded motion sensor firmware.
     */
    artifactsFirmwareMotionSensorDownload(requestParameters: ArtifactsFirmwareMotionSensorDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * Creates request options for artifactsGetCurrentVersions without sending the request
     * @throws {RequiredError}
     * @memberof ArtifactsApiInterface
     */
    artifactsGetCurrentVersionsRequestOpts(): Promise<runtime.RequestOpts>;

    /**
     * This function is exclusively used during the testing phase and is designed to return the latest versions every time it is invoked. This ensures that even if the version changes during runtime, the most up-to-date version is always returned.
     * @summary Return current versions of all artifacts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtifactsApiInterface
     */
    artifactsGetCurrentVersionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CurrentArtifactVersions>>;

    /**
     * This function is exclusively used during the testing phase and is designed to return the latest versions every time it is invoked. This ensures that even if the version changes during runtime, the most up-to-date version is always returned.
     * Return current versions of all artifacts.
     */
    artifactsGetCurrentVersions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CurrentArtifactVersions>;

    /**
     * Creates request options for artifactsGetDownloadToken without sending the request
     * @throws {RequiredError}
     * @memberof ArtifactsApiInterface
     */
    artifactsGetDownloadTokenRequestOpts(): Promise<runtime.RequestOpts>;

    /**
     * This token is used for authentication when downloading the mobile application.
     * @summary Get a download token via the user login token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtifactsApiInterface
     */
    artifactsGetDownloadTokenRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DownloadToken>>;

    /**
     * This token is used for authentication when downloading the mobile application.
     * Get a download token via the user login token
     */
    artifactsGetDownloadToken(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DownloadToken>;

    /**
     * Creates request options for artifactsGetElooperatorProvisioningPayload without sending the request
     * @throws {RequiredError}
     * @memberof ArtifactsApiInterface
     */
    artifactsGetElooperatorProvisioningPayloadRequestOpts(): Promise<runtime.RequestOpts>;

    /**
     * Assembles the ready-to-encode QR payload for the device setup (Device Owner) flow, so that clients only need to render it. See [`build_elooperator_provisioning_payload`].
     * @summary Return the Android Enterprise provisioning payload for `ELOoperator`.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtifactsApiInterface
     */
    artifactsGetElooperatorProvisioningPayloadRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProvisioningPayload>>;

    /**
     * Assembles the ready-to-encode QR payload for the device setup (Device Owner) flow, so that clients only need to render it. See [`build_elooperator_provisioning_payload`].
     * Return the Android Enterprise provisioning payload for `ELOoperator`.
     */
    artifactsGetElooperatorProvisioningPayload(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProvisioningPayload>;

}

/**
 * 
 */
export class ArtifactsApi extends runtime.BaseAPI implements ArtifactsApiInterface {

    /**
     * Creates request options for artifactsAndroidAppApkDownload without sending the request
     */
    async artifactsAndroidAppApkDownloadRequestOpts(requestParameters: ArtifactsAndroidAppApkDownloadRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['expectedVersion'] == null) {
            throw new runtime.RequiredError(
                'expectedVersion',
                'Required parameter "expectedVersion" was null or undefined when calling artifactsAndroidAppApkDownload().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/artifacts/android_app/{expected_version}`;
        urlPath = urlPath.replace('{expected_version}', encodeURIComponent(String(requestParameters['expectedVersion'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Authentication is done via login or download token.  This route is special and has different behavior in dev mode. It and serves the current artifact directly from the disk, with the version number that\'s found in the `.env` file.
     * Return embedded Android app apk for download.
     */
    async artifactsAndroidAppApkDownloadRaw(requestParameters: ArtifactsAndroidAppApkDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const requestOptions = await this.artifactsAndroidAppApkDownloadRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Authentication is done via login or download token.  This route is special and has different behavior in dev mode. It and serves the current artifact directly from the disk, with the version number that\'s found in the `.env` file.
     * Return embedded Android app apk for download.
     */
    async artifactsAndroidAppApkDownload(requestParameters: ArtifactsAndroidAppApkDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.artifactsAndroidAppApkDownloadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for artifactsAndroidElooperatorApkDownload without sending the request
     */
    async artifactsAndroidElooperatorApkDownloadRequestOpts(requestParameters: ArtifactsAndroidElooperatorApkDownloadRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['expectedVersion'] == null) {
            throw new runtime.RequiredError(
                'expectedVersion',
                'Required parameter "expectedVersion" was null or undefined when calling artifactsAndroidElooperatorApkDownload().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/artifacts/android_elooperator/{expected_version}`;
        urlPath = urlPath.replace('{expected_version}', encodeURIComponent(String(requestParameters['expectedVersion'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Authentication is done via login or download token.  This route is special and has different behavior in dev mode. It serves the current artifact directly from the disk, with the version number that\'s found in the `.env` file.
     * Return embedded Android `ELOoperator` APK for download.
     */
    async artifactsAndroidElooperatorApkDownloadRaw(requestParameters: ArtifactsAndroidElooperatorApkDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const requestOptions = await this.artifactsAndroidElooperatorApkDownloadRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Authentication is done via login or download token.  This route is special and has different behavior in dev mode. It serves the current artifact directly from the disk, with the version number that\'s found in the `.env` file.
     * Return embedded Android `ELOoperator` APK for download.
     */
    async artifactsAndroidElooperatorApkDownload(requestParameters: ArtifactsAndroidElooperatorApkDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.artifactsAndroidElooperatorApkDownloadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for artifactsAndroidEloserviceApkDownload without sending the request
     */
    async artifactsAndroidEloserviceApkDownloadRequestOpts(requestParameters: ArtifactsAndroidEloserviceApkDownloadRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['expectedVersion'] == null) {
            throw new runtime.RequiredError(
                'expectedVersion',
                'Required parameter "expectedVersion" was null or undefined when calling artifactsAndroidEloserviceApkDownload().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/artifacts/android_eloservice/{expected_version}`;
        urlPath = urlPath.replace('{expected_version}', encodeURIComponent(String(requestParameters['expectedVersion'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Authentication is done via login or download token.  This route is special and has different behavior in dev mode. It serves the current artifact directly from the disk, with the version number that\'s found in the `.env` file.
     * Return embedded Android `ELOservice` APK for download.
     */
    async artifactsAndroidEloserviceApkDownloadRaw(requestParameters: ArtifactsAndroidEloserviceApkDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const requestOptions = await this.artifactsAndroidEloserviceApkDownloadRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Authentication is done via login or download token.  This route is special and has different behavior in dev mode. It serves the current artifact directly from the disk, with the version number that\'s found in the `.env` file.
     * Return embedded Android `ELOservice` APK for download.
     */
    async artifactsAndroidEloserviceApkDownload(requestParameters: ArtifactsAndroidEloserviceApkDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.artifactsAndroidEloserviceApkDownloadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for artifactsFirmwareEloboxDownload without sending the request
     */
    async artifactsFirmwareEloboxDownloadRequestOpts(requestParameters: ArtifactsFirmwareEloboxDownloadRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['expectedVersion'] == null) {
            throw new runtime.RequiredError(
                'expectedVersion',
                'Required parameter "expectedVersion" was null or undefined when calling artifactsFirmwareEloboxDownload().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/artifacts/firmware/vehicle_device/{expected_version}`;
        urlPath = urlPath.replace('{expected_version}', encodeURIComponent(String(requestParameters['expectedVersion'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * This route is special and has different behavior in dev mode. It and serves the current artifact directly from the disk, with the version number that\'s found in the `.env` file.
     * Return embedded ELObox firmware.
     */
    async artifactsFirmwareEloboxDownloadRaw(requestParameters: ArtifactsFirmwareEloboxDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const requestOptions = await this.artifactsFirmwareEloboxDownloadRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * This route is special and has different behavior in dev mode. It and serves the current artifact directly from the disk, with the version number that\'s found in the `.env` file.
     * Return embedded ELObox firmware.
     */
    async artifactsFirmwareEloboxDownload(requestParameters: ArtifactsFirmwareEloboxDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.artifactsFirmwareEloboxDownloadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for artifactsFirmwareMotionSensorDownload without sending the request
     */
    async artifactsFirmwareMotionSensorDownloadRequestOpts(requestParameters: ArtifactsFirmwareMotionSensorDownloadRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['expectedVersion'] == null) {
            throw new runtime.RequiredError(
                'expectedVersion',
                'Required parameter "expectedVersion" was null or undefined when calling artifactsFirmwareMotionSensorDownload().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/artifacts/firmware/motion_sensor/{expected_version}`;
        urlPath = urlPath.replace('{expected_version}', encodeURIComponent(String(requestParameters['expectedVersion'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * This route is special and has different behavior in dev mode. It and serves the current artifact directly from the disk, with the version number that\'s found in the `.env` file.
     * Return embedded motion sensor firmware.
     */
    async artifactsFirmwareMotionSensorDownloadRaw(requestParameters: ArtifactsFirmwareMotionSensorDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const requestOptions = await this.artifactsFirmwareMotionSensorDownloadRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * This route is special and has different behavior in dev mode. It and serves the current artifact directly from the disk, with the version number that\'s found in the `.env` file.
     * Return embedded motion sensor firmware.
     */
    async artifactsFirmwareMotionSensorDownload(requestParameters: ArtifactsFirmwareMotionSensorDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.artifactsFirmwareMotionSensorDownloadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for artifactsGetCurrentVersions without sending the request
     */
    async artifactsGetCurrentVersionsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/artifacts/current_versions`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * This function is exclusively used during the testing phase and is designed to return the latest versions every time it is invoked. This ensures that even if the version changes during runtime, the most up-to-date version is always returned.
     * Return current versions of all artifacts.
     */
    async artifactsGetCurrentVersionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CurrentArtifactVersions>> {
        const requestOptions = await this.artifactsGetCurrentVersionsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CurrentArtifactVersionsFromJSON(jsonValue));
    }

    /**
     * This function is exclusively used during the testing phase and is designed to return the latest versions every time it is invoked. This ensures that even if the version changes during runtime, the most up-to-date version is always returned.
     * Return current versions of all artifacts.
     */
    async artifactsGetCurrentVersions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CurrentArtifactVersions> {
        const response = await this.artifactsGetCurrentVersionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for artifactsGetDownloadToken without sending the request
     */
    async artifactsGetDownloadTokenRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/artifacts/download_token`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * This token is used for authentication when downloading the mobile application.
     * Get a download token via the user login token
     */
    async artifactsGetDownloadTokenRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DownloadToken>> {
        const requestOptions = await this.artifactsGetDownloadTokenRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DownloadTokenFromJSON(jsonValue));
    }

    /**
     * This token is used for authentication when downloading the mobile application.
     * Get a download token via the user login token
     */
    async artifactsGetDownloadToken(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DownloadToken> {
        const response = await this.artifactsGetDownloadTokenRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for artifactsGetElooperatorProvisioningPayload without sending the request
     */
    async artifactsGetElooperatorProvisioningPayloadRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/artifacts/elooperator_provisioning_payload`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Assembles the ready-to-encode QR payload for the device setup (Device Owner) flow, so that clients only need to render it. See [`build_elooperator_provisioning_payload`].
     * Return the Android Enterprise provisioning payload for `ELOoperator`.
     */
    async artifactsGetElooperatorProvisioningPayloadRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProvisioningPayload>> {
        const requestOptions = await this.artifactsGetElooperatorProvisioningPayloadRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProvisioningPayloadFromJSON(jsonValue));
    }

    /**
     * Assembles the ready-to-encode QR payload for the device setup (Device Owner) flow, so that clients only need to render it. See [`build_elooperator_provisioning_payload`].
     * Return the Android Enterprise provisioning payload for `ELOoperator`.
     */
    async artifactsGetElooperatorProvisioningPayload(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProvisioningPayload> {
        const response = await this.artifactsGetElooperatorProvisioningPayloadRaw(initOverrides);
        return await response.value();
    }

}
